module.exports = __webpack_public_path__ + "static/media/6.1b2c8235.jpg";